import React, { useEffect } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import GridItem from '../../Grid/GridItem.js';
import GridContainer from '../../Grid/GridContainer.js';
import Button from '../../CustomButtons/Button.js';
import { connect } from 'react-redux';
import { getUserDetails as getUserList } from '../../../store/actions/user/User';
import CardIcon from '../../Card/CardIcon.js';
import Card from '../../Card/Card.js';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Store from '@material-ui/icons/Store';
import DateRange from '@material-ui/icons/DateRange';
import LocalOffer from '@material-ui/icons/LocalOffer';
import Update from '@material-ui/icons/Update';
import Accessibility from '@material-ui/icons/Accessibility';
import CardHeader from '../../Card/CardHeader.js';
import CardBody from '../../Card/CardBody.js';
import CardFooter from '../../Card/CardFooter.js';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);
var update = false;
function Dashboard(props) {
  useEffect(() => {
    props.getUserList();
  }, [update]);
  const classes = useStyles();
  return (
    <>
      <Card>
        <CardHeader
          style={{
            background:
              'linear-gradient(90deg, rgb(22, 183, 144), rgb(54, 186, 146), rgb(52, 142, 140))'
          }}
        >
          <h4 className={classes.cardTitleWhite}>My Profile</h4>
          <p className={classes.cardCategoryWhite}>
            Orders and personnal informations
          </p>
        </CardHeader>
        <CardBody>
          <GridContainer>
            {/*
              <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Used Space</p>
              <h3 className={classes.cardTitle}>
                49/50 <small>GB</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  Get more space
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      */}
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="success" stats icon>
                  <CardIcon color="success">
                    <Store />
                  </CardIcon>
                  <p className={classes.cardCategory}>Orders</p>
                  <h3 className={classes.cardTitle}>$0</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange style={{ marginTop: '-9px' }} />
                    Last 24 Hours
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="danger" stats icon>
                  <CardIcon color="danger">
                    <Icon>info_outline</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>Fixed Issues</p>
                  <h3 className={classes.cardTitle}>0</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <LocalOffer style={{ marginTop: '-9px' }} />
                    From Admin
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="info" stats icon>
                  <CardIcon color="info">
                    <Accessibility />
                  </CardIcon>
                  <p className={classes.cardCategory}>Vendors Following</p>
                  <h3 className={classes.cardTitle}>0</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <Update style={{ marginTop: '-9px' }} />
                    Just Updated
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button style={{ background: '#34BA92' }}>Start Ordering</Button>
        </CardFooter>
      </Card>
    </>
  );
}

const mapStateWithProps = (state) => ({
  userDetails: state.user.userDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getUserList: () => dispatch(getUserList())
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Dashboard);
